<template>
<div class="project wrapper">
  <h1>{{ project.title }}</h1>
  <img :src="`/static/img/${project.image}`" :alt="project.image"/>
  <p>{{ project.about }}</p>
  <a :href="`${project.url}`">Visit page..</a>
</div>
</template>

<script>
export default {
  name: 'projects',
  data () {
    return {
      project: {}
    }
  },
  async mounted () {
    try {
      const resp = await fetch(`https://gigavoid.com/api/project/${this.$route.params.id}`)
      this.project = await resp.json()
    } catch (err) {
      console.log(err)
    }
  }
}
</script>

<style scoped>
img {
  width: calc(100% - 20px);
  max-height: 200px;
}

.project {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/project.vue